import MuiDrawer from '@mui/material/Drawer';
import { PropsWithChildren } from 'react';

interface MobileDrawerProps extends PropsWithChildren<{ open: boolean; onClose: () => void }> {
}

const MobileDrawer = ({ open, onClose, children }: MobileDrawerProps) => (
    <MuiDrawer
        variant="temporary"
        anchor="left"
        open={open}
        onClose={onClose}
        ModalProps={{
            keepMounted: true,
            BackdropProps: {
                sx: { backgroundColor: 'rgba(0, 0, 0, 0.4)' }
            }
        }}
        transitionDuration={{ enter: 250, exit: 200 }}
        PaperProps={{
            sx: {
                width: 240,
                maxWidth: '80vw'
            }
        }}
    >
        {children}
    </MuiDrawer>
);

export default MobileDrawer;
